<!--首页-->
<template>
  <div>
    <div class="box"> 
          <div class="activity-detail-top" >
            <div class="top-info">
              <div class="info-top-box">
                <!--<img :src="row.pic_url" alt srcset />-->
                <div class="activity-detail-title">{{cate_row.name}}</div>
                <div class="activity-detail-desc">{{cate_row.s_name}}</div>
              </div>  
            </div>
          </div>


    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"> 
            <div class="sai-itmes" :key="key" v-for="(item,key) in list">
              <div class="items-top1">
                <div
                    class="train-items-top show-two-row"
                    :style="'background-image:linear-gradient(to right, rgb(43, 122, 255), rgb(30, 178, 255));'"
                >
              <div  class="sai-type-tip">国际</div>  
                  <div class="train-items-top-city">{{ cate_row.name}}</div>
                  <div class="train-items-top-time">{{ item.jingwai_start_time }} </div>
                </div>

                <div style="text-align: center;margin-top: .1rem">
                  {{item.jingwai_baoming_end}}开始报名
                </div>
              </div>

              <div style="flex:1;" class="sai-info-box">
                <p class="sai-title show-two-row">{{ item.title }}</p>  
                <div class="items-btn"> 
                  <div
                      class="sai-into" 
                      v-rblink="{name:'NewsDetail',query:{id:item.jingwai_tongzhi_id}}"
                  >通知文件
                  </div>
                </div>
              </div> 
        </div>
      </van-list>
    </van-pull-refresh>
   
    </div> 
 
  
  </div>
</template>
<style scoped>
/* @import '../../assets/style/index.css'; */

.sai-type-tip {
  width: 1rem;
  color: #fff;
  font-size: .24rem;
  background: linear-gradient(
      140deg, rgb(253, 157, 0) 0%, rgb(250, 100, 0) 100%);
  border-radius: 10px 0px 10px 0px;
  /*position: absolute;*/
  /*top: 0;*/
}

.train-items-top {
  /* flex: 1; */
  /*position: relative;*/
  width: 1.9rem;
  /*height: 1.3rem;*/
  border-radius: 10px;
  display: flex;
  text-align: center;
  /*align-items: baseline;*/
  flex-direction: column;
  justify-content: center;
  /*padding-left: 0.1rem;*/
  margin-right: 0.1rem;
}
.train-items-top-city {
  font-size: .32rem;
  color: #fff;
  overflow: hidden;
  padding-top: .05rem;
  /*height: 0.88rem;*/
}

.train-items-top-time {
  font-size: .28rem;
  color: #fff;
  padding-bottom: .1rem;
}

.year-left-btn,
.year-right-btn {
  font-size: 16px;
  display: flex;
  align-items: center;
}

.year-month {
  text-align: center;
  display: flex;
  justify-content: center;
  padding: 0 0.4rem;
  font-size: 16px;
  font-weight: bold;
  align-items: center;
}

.offline2 {
  background: linear-gradient( 140deg, #0559ad 0%, #1989fa 100%);
}
.offline {
  background: linear-gradient(
      140deg, #44D7B6 0%, #44D7B6 100%);
}
.sai-info-box {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  /* height: 1rem; */
}

.sai-info-box .items-btn {
  display: flex;
}

.sai-into {
  width: 1rem;
  height: 0.5rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 14px;
  border: 1px solid rgba(231, 46, 41, 1);
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(230, 56, 56, 1);
  line-height: 0.5rem;
  text-align: center;
}

.sai-join {
  width: 1rem;
  height: 0.5rem;
  background: linear-gradient(
      130deg,
      rgba(243, 95, 95, 1) 0%,
      rgba(228, 49, 49, 1) 100%
  );
  border-radius: 14px;
  font-size: 12px;
  margin-right: 6px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.5rem;
  text-align: center;
}

.info-address,
.info-data {
  height: 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 16px;
  overflow: hidden;
}

.info-status-0 {
  height: 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: rgba(250, 173, 20, 1);
  line-height: 16px;
  /*max-width: 1.1rem;*/
  overflow: hidden;
}

.info-status-1 {
  height: 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: #2e8404;
  line-height: 16px;
}

.sai-title {
  /*height: 21px;*/
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  margin-bottom: .2rem;
  color: #333333;
}

.sai-info {
  display: flex;
}

.sai-info span {
  margin-right: 10px;
}

.sai-img {
  width: 1rem;
  height: 1rem;
  display: block;
  margin-right: 10px;
}

.sai-data-items {
  width: 7.1rem;
  margin: 0 auto;
  padding-bottom: 10px;
}

.sai-data-year {
  padding: .2rem .3rem;
  margin-bottom: .2rem;
  border-radius: .1rem;
  background: #fff;
}

.sai-itmes {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding: 15px 13px;
  align-items: flex-start;
  background: #fff;
  margin-bottom: .2rem;
  border-radius: 10px;
}

.sai-items-box {
  width: 7.1rem;
  /* height:323px; */
  /*background: rgba(255, 255, 255, 1);*/
  /*border-radius: 10px;*/
  padding: 10px 0;
}

.to-form-add {
  width: 1.1rem;
  height: 1.1rem;
  position: fixed;
  right: 0.2rem;
  top: 9rem;
  z-index: 3;
}
.to-form-add img {
  width: 100%;
}
.send-btn {
  width: 1.3rem;
  height: 38px;
  background: linear-gradient(
    90deg,
    rgba(254, 200, 53, 1) 0%,
    rgba(255, 173, 25, 1) 100%
  );
  border-radius: 4px;
  margin-left: 12px;
  line-height: 38px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.send-comment {
  width: 7.1rem;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}
.comment-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1.08rem;
  background: rgba(247, 247, 247, 1);
  border: 1px solid rgba(236, 236, 236, 1);
}
.release-time-right {
  display: flex;
}
.icon-zan-comment-box {
  width: 175px;
  height: 38.5px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
}
.activity-place {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
}
.detail-header {
  height: 40px;
  padding: 10px 10px;
  background: #fff;
}
.user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.user-face img {
  height: 32px;
  width: 32px;
}
.user-info {
  margin-left: 5px;
  float: left;
}
.user-info view {
  height: 50px;
  line-height: 50px;
}
.user-names {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.look-info {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  line-height: 17px;
}
.video-bottom {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 5px;
}
.video-box img {
  margin-top: 10px;
  width: 100%;
}
.active-items-title-read {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 58%;
}
.active-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.active-item-pics {
  width: 40%;
}
.active-item-pics img {
  width: 100%;
  height: 1.4rem;
}
.acitve-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
}
.active-itme-read {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.acitve-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
}
.video-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
}
.active-tab {
  margin-top: 0.6rem;
}
.active-tab-num {
  width: 0.34rem;
  height: 0.34rem;
  background: #f05656;
  text-align: center;
  line-height: 0.34rem;
  display: block;
  position: absolute;
  right: -10px;
  top: -10px;
  border-radius: 0.34rem;
  color: #fff;
}
.active-tab >>> .van-tab__text {
  position: relative;
}
.active-tab >>> .van-tabs__nav {
  background: #f8f8f8;
}
.active-tab >>> [class*="van-hairline"]::after {
  border-top: none;
}
.activity-detail-top {
  width: 100%;
  background-size: 100% 4.69rem;
  background: url("../../../assets/images/activity/pic-shuo-top-1@2x.png")
    no-repeat;
  background-size: 100%;
  position: relative;
  overflow: hidden;
}
.top-info {
  width: 6.9rem;
  /*height: 5.3rem;*/
  background: rgba(255, 255, 255, 1);
  border-radius: 7px;
  margin: 2.1rem auto;
  margin-bottom: 0;
  /* display: flex; */
  /* flex-direction: column; */
}
.info-top-box {
  /*height: 1.45rem;*/
  padding: 0.26rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
  margin: 150px  0 0 0 ;
}
.info-top-box img {
  width: 1.08rem;
  height: 1.08rem;
  position: absolute;
  top: -0.36rem;
}
.activity-detail-title {
  font-size: 19px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin: 5px 0;
  /*text-indent: 1.34rem;*/
}
.activity-detail-desc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 18px;
}
.info-main-box {
  /* height: 2.4rem; */
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  padding: 0.2rem;
}
.activity-dynamic {
  height: 33px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 33px;
  text-indent: 0.28rem;
}
.info-dynamic-items {
  display: flex;
  /*justify-content: space-between;*/
  /*flex: 1;*/
  /*flex-wrap: nowrap;*/
  /*overflow-y: scroll;*/
  justify-content: flex-start;
  flex-wrap: wrap;
}
.info-dynamic-items .dynamic-item {
  /*min-width: 25%;*/
  min-width: 20%;
  max-width: 20%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
   margin-bottom: 0.1rem;
}
.dynamic-item img {
  width: 0.6rem;
  height: 0.6rem;
  display: block;
  margin-bottom: 0.12rem;
}

.info-bottom-box {
  flex: 1;
  display: flex;
  align-items: center;
}
.info-bottom-box img {
  width: 24px;
  height: 24px;
  display: block;
  margin: 0 0.16rem 0 0.28rem;
}
.start-immediately {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  margin-left: 0.14rem;
}
.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
</style>

<script>
import Vue from "vue";

import jquery from 'jquery';
import { Tab, Tabs, Toast, Field, List, PullRefresh,ActionSheet,Dialog } from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(Toast)
  .use(Field)
  .use(PullRefresh)
  .use(Dialog)
  .use(List).use(ActionSheet);
import Activity1 from "@/components/activity/Activity1.vue";
import Activity2 from "@/components/activity/Activity2.vue";
import Activity3 from "@/components/activity/Activity3.vue";
import Activity4 from "@/components/activity/Activity4.vue";
import Activity5 from "@/components/activity/Activity5.vue";

import LoginDialog from "@/components/LoginDialog.vue";
import NavFloatService from "@/components/NavFloatService.vue";
import NavFloatAdd from "@/components/NavFloatAdd.vue";
import NavFloatShare from "@/components/NavFloatShare.vue";

import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";

import { getTimeFormat } from "../../../utils/date.js";

export default {
  name: "Activity",
  components: {
    Activity1,
    Activity2,
    Activity3,
    Activity4,
    Activity5,
    LoginDialog,
    NavFloatService,
    NavFloatShare,
    NavFloatAdd,
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4
  },
  data: function() {
    return {
      shisuShow:false,
      isLoading: false,
      showKefu: false,
      showZhibo: false,
      showZhibom: true,
      loading: false,
      finished: false,
      loginShow: false,
      sheetActiveShow:false,
      sheetCommentShow:false,
      Loop: null,
      active: 0,
      activeTab: [
        { name: "文件", num: 0, type: -1 },
        { name: "动态", num: 0, type: 0 },
        { name: "图片", num: 0, type: 1 },
        // { name: "视频", num: 0, type: 2 }
      ],
      sheetActiveActions: [{ name: '删除主题' }],
      sheetCommentActions: [{ name: '删除评论' }],
        list: [],
        cate_row: {

        },
      row: {
        id: 0,
        pic: [],
        pics: [],
        list: [],
        hotel:{},
        take_list:{},
        bus_list:{},
        saiqu:{
          erweiimg_pic_url: '',
          zhibo_pic_urls: []
        }
      },
      params: {
        id: 0,
        type: -1, // -1文件 0动态 1是图片  2是视频
        pageNo: 1
      },
      message: "",
      sendShow: false,
      item: {}, //当前评论的item
      list_index: 0, //当前评论的列表下标
      to_comment_id: 0, //点击评论回复其人的id
      placeholder: "说点什么...",
      touchstartId:0, //长按后的id
      touchstartIndex:0 ,//长按后的下标
      commentIndex:0,//长按后评论下标

      copy_text: '',
      showWxShare: false,
      show_share_panel: false,
      share_data:{},

      ltImgSrc: '',
      ltImgName: '',
      list:[],
      ltActions: [{name: '保存图片'}],

      ltShow: false,
    };
  },
  filters: {
    getTimeFormat: getTimeFormat
  },
  mounted() {
    document.title = "活动";
    this.row.id = this.$route.query.id;
    this.params.cate_id = this.$route.query.cate_id;

    this.params.pageNo = 1;
    this.loading = true;
    this.finished = false;
    // this.fetch();
    this.getList();
  },
  destroyed() {},
  methods: {

    getList() {
      let that = this;
      that.$api.get("/api/cms/cmslist", that.params, res => {
        that.loading = false;
        that.isLoading = false;
 
        that.list = res.data.list;
        that.cate_row = res.data.cate_row;
        that.finished = true;
      });
    },

    onLtSelect(item) {
      let that = this;
      switch (item.name) {
        case '保存图片':
          console.log(that.ltImgSrc, that.ltImgName);
          appEvent({
            name: 'downloadPic',
            query: {
              'filename': that.ltImgName,
              'url': that.ltImgSrc
            }
          });
          break;
      }
    },
    onZhibo(){
      let that = this;
      if(this.row.saiqu.zhibo_pic.length > 0){
        // 显示图片
        this.showZhibo = true

          setTimeout(() => {
            jquery('img').each(function () {
              jquery(this).unbind();
              jquery(this).longPress(() => {
                console.log('longPress', jquery(this).attr('src'));
                that.ltImgSrc = jquery(this).attr('src')
                that.ltImgName = jquery(this).attr('title')
                that.ltShow = true;
              });
            })
          }, 500);
        return
      } else if(this.row.saiqu.zhibo_url) {
        rbLink({
          name: 'H5',
          query: {
            url: this.row.saiqu.zhibo_url
          }
        })
      }else{
        Toast('暂未开通!');
      }
    },

    // 信息核对
    onInfoConfirm() {
      // saiConfirmManage
      let that = this;
      rbLink({
        name: 'saiConfirmManage',
        query: {
          saiqu:that.row.saiqu.id
        }
      })
    },
    onWenjuan(){
      if(this.row.saiqu.wenjuanxing_url) {
        rbLink({
          name:'H5',
          query:{
            url: this.row.saiqu.wenjuanxing_url
          }
        })
      } else {
        Toast('暂未开通!');
      }
    },
    onZhiboDownload(){
      if(this.row.saiqu.zhibo_pic_urls.length>0){
        this.download({
          name:this.row.saiqu.name + '直播二维码',
          url:this.row.saiqu.zhibo_pic_urls
        })
      }else{
        Toast('暂未生成!');
      }
    },
    onZhixuce(){
      if(this.row.saiqu.zhixuce_url){
        this.download({
          name:this.row.saiqu.zhixuce_name,
          url:this.row.saiqu.zhixuce_url
        })
      }else{
        Toast('暂未生成!');
      }
    },
    onShowShisu(){
      if(!this.row.show_shisu){
        Toast('本赛区您没有成功的报名记录!');
      }else{
        this.shisuShow=true;
      }

    },
    onResults(){
      if(this.row.saiqu.results_book_url){
        this.download({
          name:this.row.saiqu.results_book_name,
          url:this.row.saiqu.results_book_url
        })
      }else{
        Toast('暂未生成!');
      }
    },
    onShisu(){
      Toast('暂未开通!');
    },
    activeDetele(){
      //删除话题
      let that=this
      console.log('shanchu',this.touchstartId)
      that.$api.get(
        "/api/activity/topicDelete",
        {id:this.touchstartId},
        res => {
          this.row.list.list.splice(this.touchstartIndex,1)
           Toast('删除成功!');
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    CommentDetele(){
      //删除评论
      let that=this
      let id=this.row.list.list[this.touchstartIndex].comment_list[this.commentIndex].id
      that.$api.get(
        "/api/activity/commentDelete",
        {id:id},
        res => {
          this.row.list.list[this.touchstartIndex].comment_list.splice(that.commentIndex,1)
           Toast('删除成功!');
        },
        res => {
          Toast(res.msg);
        }
      );
    },

    onSelect(action,index){
      console.log(action,index)
      switch (action.name){
        case '删除主题':
          this.activeDetele()
        break;
        case '删除评论':
           this.CommentDetele()
        break;
      }
    },
    onSheetCancel() {
      // Toast('取消');
    },
    onDeleteActive(event,item,i){
      //删除主题
      this.touchstartId=item.id
      this.touchstartIndex=i
      this.sheetActiveShow=true
    },
    onDeleteComment(event,i){
      // 删除评论
      console.log(event,i)
      this.touchstartIndex=i
      this.commentIndex=event
      this.sheetCommentShow=true
    },
    onClick(name, title) {
      console.log(name);
      this.params.type = this.activeTab[name].type;
      this.params.pageNo = 1;
      // this.fetch();
      this.getList();
    },
    toActivityDetail(item) {
      let that = this;
      that.$router.push({
        path: "/activity-activity-detail",
        query: {
          id: item.id
        }
      });
    },
    fetch() {
      let that = this;
      that.$api.get(
        "/api/activity/activity",
        that.params,
        res => {
          that.loading = false;

          if (res.data.list.currentpage == 1) {
            that.isLoading = false;
            that.row = res.data;
          } else {
            that.row.list.list = that.row.list.list.concat(res.data.list.list);
          }

          if (res.data.list.list.length == 0) {
            that.finished = true;
          }
          that.params.pageNo += 1;

        that.share_data = res.data.share_data;
        that.copy_text = res.data.share_data.url;


        if (window.isApp()) {
        // if (true) {
          setTimeout(() => {
            jquery('img').each(function () {
              jquery(this).unbind();
              jquery(this).longPress(() => {
                console.log('longPress', jquery(this).attr('src'));
                that.ltImgSrc = jquery(this).attr('src')
                that.ltImgName = jquery(this).attr('title')
                that.ltShow = true;
              });
            })
          }, 500);
          return false;
        }
        },
        res => {
          // Toast(res.msg);

					console.log('没有登录');
					if (res.code == 401 || res.code==402) {
						if(window.isApp()){
							rbLink({
								name:'login','query':{ }
							},'replace');
							return false;
						}
						that.loginShow = true
					}else {
						Toast(res.msg)
					}
        }
      );
    },

			loginSuccess(res){
				console.log('-------登录成功--------',res);
				this.loginShow = false;
				this.getList();
				// this.fetch();
			},

			loginCancel(){
				console.log('-------取消登录--------');
				// this.loginShow = false;
			},
    onSendBox(event, item, i) {
      // console.log(event)
      this.sendShow = event.sendShow;
      this.to_comment_id = event.comment_.id;
      this.placeholder = event.comment_.user_name
        ? "@" + event.comment_.user_name
        : "说点什么...";
      (this.item = item), (this.list_index = i);
    },
    onLoginStatus(event) {
      this.loginShow = true;
    },
    onCommentSend() {
      let that = this;
      console.log("发送评论", this.item, this.message);
      that.$api.get(
        "/api/activity/commentAdd",
        {
          topic_id: this.item.id,
          content: this.message,
          to_comment_id: this.to_comment_id
        },
        res => {
          console.log(res);
          this.row.list.list[this.list_index].comment_list.push(res.data);
          this.message = "";
        },
        res => {

          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                      {
                        name: "login",
                        query: {}
                      },
                      "replace"
              );
              return false;
            }
            that.loginShow = true
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          // this.fetch();
          this.getList
        }, 500);
      }
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      // this.fetch();
      this.getList();
    },

    loginCancel() {
      console.log("-------取消登录--------");
       this.loginShow = false;
    },
    showDeleteButton(e) {
      clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
      this.Loop = setTimeout(
        function() {
          console.log(e)
          if(e.is_admin){
            this.activeListId=e.id
            this.sheetActiveShow=true
          }
        }.bind(this),
        800
      );
    },
    emptyTime() {
      clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
    },

    download(file){
      appEvent({
        name: 'downloadFile',
        query: {
          name:file.name,
          url:file.url,
        }
      });
    },



    onShareCancel() {
      this.showWxShare = false;
    },


    shareWeixinFriend() {
      console.log('shareWeixinFriend')
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinFriend',
          query: that.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
    shareWeixinTimeLine() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinTimeLine',
          query: that.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;

      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// GuojijiaoliuDetail.vue?2a339940